export enum ChatMessageType {
	CustomerToMerchant = 1,
	MerchantToCustomer = 2,

	CustomerToSupport = 3,
	SupportToCustomer = 4,

	MerchantToSupport = 5,
	SupportToMerchant = 6,

	SystemToCustomer = 7,
	SystemToMerchant = 8,

	RiderToMerchant = 12,
	MerchantToRider = 13,

	CustomerToRider = 9,
	RiderToCustomer = 10,
	SystemToDriver = 11
}
